export const DEBOUNCE_DELAY = 500;
export const MAX_FILE_SIZE_KB = 2048;
export const fileSizeInKB = (file: File) => {
  return file.size / 1024;
};
